"use strict";

exports.__esModule = true;
exports.default = flatten;
var _flatten2 = _interopRequireDefault(require("./_flatten.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array, depth) {
  return (0, _flatten2.default)(array, depth, false);
}